import { FormattedMessage } from 'react-intl';
import { omit } from 'lodash';

// Components
import SetupGridItem from '../SetupGridItem';
import { SetupValue } from '../AffordableSetup/Programs/shared';

// Constants
import messages from './messages';
import { CDLAC_NUMBER_VALIDATION_REGEX } from '../constants';

// Types
import type { PropertyStateConfigValues } from '../types';

type Props = {
  editMode: boolean,
  onChange: Function,
  affordableProgramName?: string,
} & PropertyStateConfigValues;

function PropertyStateConfig({
  editMode,
  onChange,
  state,
  stateConfigs,
  affordableProgramName = null,
}: Props) {
  const showCDLACNumber = state === 'US-CA';
  const CDLACNumber = stateConfigs.find(
    (stateConfig) =>
      stateConfig.key === 'CDLACNumber' &&
      (stateConfig.affordableProgramFilter?.includes(affordableProgramName) ||
        affordableProgramName === null),
  );

  const handleStateConfigChange = (evt) => {
    const key = evt.target.name;
    const value = evt.target.value || null; // Prefer null over empty string

    const updatedStateConfig = stateConfigs.find(
      (stateConfig) =>
        stateConfig.key === key &&
        (stateConfig.affordableProgramFilter?.includes(affordableProgramName) ||
          affordableProgramName === null),
    );

    const updatedStateConfigs = [
      ...stateConfigs.filter(
        (stateConfig) =>
          stateConfig.key !== key ||
          !stateConfig.affordableProgramFilter?.includes(affordableProgramName),
      ),
      updatedStateConfig
        ? { ...omit(updatedStateConfig, 'state'), value }
        : {
            key,
            value,
            affordableProgramFilter: [affordableProgramName],
          },
    ];

    onChange({ target: { name: 'stateConfigs', value: updatedStateConfigs } });
  };

  // Only contain CDLAC Number for now, but can be expanded to contain more state configs.
  return (
    showCDLACNumber && (
      <SetupGridItem
        label={<FormattedMessage {...messages.CDLACNumber} />}
        TooltipProps={{
          title: <FormattedMessage {...messages.CDLACNumberToolTip} />,
        }}
      >
        <SetupValue
          editMode={editMode}
          name="CDLACNumber"
          value={CDLACNumber?.value}
          onChange={handleStateConfigChange}
          placeholder="i.e. 1234-567"
          validateFunction={(value) =>
            !value || CDLAC_NUMBER_VALIDATION_REGEX.test(value)
          }
          message={messages.invalidCDLACNumber}
          required
        />
      </SetupGridItem>
    )
  );
}

export default PropertyStateConfig;
